<span [innerHTML]="monitor.serialNumber"></span>
